import { generateClient } from "aws-amplify/api";
import { recordSentry } from "utils/recordSentry";
import { deleteFormGroup as deleteFG } from "../db/queries/formGroupQueries";
import { deleteFormGroupsLambda } from "../graphql/mutations";

/**
 * Deletes a form group and all children instances from DB.
 * @param formGroupsToDelete document of the form group to delete
 * @param online Whether or not the user is online
 */
async function deleteFormGroups(formGroupsToDelete: { id: string }[], online: boolean) {
	const stringifiedFormGroupIdArray = JSON.stringify(formGroupsToDelete);
	try {
		if (online) {
			const client = generateClient({ authMode: "userPool" });
			await client.graphql({
				query: deleteFormGroupsLambda,
				variables: {
					stringifiedFormGroupIdArray,
				},
				authMode: "userPool",
			});
		} else {
			const promises = [];
			for (const formGroup of formGroupsToDelete) {
				promises.push(deleteFG(formGroup));
			}
			await Promise.all(promises);
		}
	} catch (error) {
		recordSentry({ error, msg: "Error deleting form group:" });
	}
}

export default deleteFormGroups;
